import { MouseEvent, useEffect } from "react";
import ShowMoreText from "react-show-more-text";
import { useDispatch, useSelector } from "react-redux";
import { Step, IStore } from "../../DataTypes/storeTypes";
import { selectProvider } from "../../Actions/providerActions";

export const Provider = () => {
    const dispatch = useDispatch();
    const { providers, selectedProviderId } = useSelector((state: IStore) => {
        const info = state.stepsInfo[state.common.currentStep];

        return {
            providers: [...state.providers],
            selectedProviderId: info.id,
        };
    });

    useEffect(() => {
        if (providers.length === 1 && !selectedProviderId) {
            dispatch(selectProvider(providers[0].id, [Step.When]));
        }
    }, [providers]);

    const handleClick = (e: MouseEvent<any>) => {
        if (e.target && $(e.target).hasClass("link-show-more")) {
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
        }
    };

    const getProvider = (
        id: number,
        pictureUrl: string,
        name: string,
        isSelected: boolean,
        extraPortalInfo: string
    ) => {
        let profilePicture = "/images/all-providers.svg";

        // first row is "All providers"
        if (id !== 0) {
            profilePicture = pictureUrl || "/images/no-photo.jpg";
        }

        return (
            <div
                key={id}
                className={`big-btn provider-big-button ${isSelected ? "selected" : ""} ${id === 0 && "all-providers"}`}
                onClick={(e) => {
                    e.preventDefault();
                    dispatch(selectProvider(id, [Step.When]));
                }}
            >
                <div className="d-block w-100">
                    <div className="row align-items-center">
                        <div className="col-4 col-md-2 text-center pr-0">
                            <div
                                className="provider-image rounded-circle"
                                style={{ backgroundImage: `url(${profilePicture})` }}
                            />
                        </div>
                        <div className="col-8 col-md-10 pl-0">
                            <div className="provider-name">{name}</div>
                            {extraPortalInfo ? (
                                <small className="provider-description" onClick={handleClick}>
                                    <ShowMoreText lines={2} anchorClass="link-show-more">
                                        {extraPortalInfo}
                                    </ShowMoreText>
                                </small>
                            ) : null}
                        </div>
                    </div>
                </div>

                {isSelected && <i className="fa fa-check" />}
            </div>
        );
    };

    const availableProviders = providers.map((p) => {
        const isSelected = p.id === selectedProviderId;
        return getProvider(p.id, p.pictureUrl, p.name, isSelected, p.extraPortalInfo);
    });

    return (
        <div className="row">
            <div className="col-11 ml-auto mr-auto">{availableProviders}</div>
        </div>
    );
};
